import React, { ReactElement, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

const TabContent = ({ children }: Props): ReactElement => <>{children}</>;

export default TabContent;
